
import React from 'react';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: 'Melanie Cope Machial',
      position: 'Head of Marketing and Technology',
      company: 'Barings Law',
      image: 'https://public.readdy.ai/ai/img_res/1670edbbf2b0ce4a13ee251c622f69bf.jpg',
      quote: 'Zoho One has transformed how we manage our business operations. The integration between all apps is seamless.'
    },
    {
      name: 'Erick Mwangi',
      position: 'CEO',
      company: 'Maridaddy',
      stat: '150%',
      statDescription: 'Boost in productivity following improvement of hundreds of processes by automation',
      image: 'https://readdy.ai/api/search-image?query=Professional%20African%20business%20man%20headshot%2C%20confident%20male%20CEO%20in%20business%20suit%2C%20corporate%20executive%20portrait%20with%20clean%20background%2C%20modern%20professional%20appearance&width=200&height=200&seq=erick-testimonial&orientation=squarish'
    },
    {
      name: 'Satyan Thukral',
      position: 'CEO',
      company: 'Caple Industrial Solutions',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Indian%20business%20man%20headshot%2C%20confident%20male%20CEO%20in%20business%20attire%2C%20corporate%20executive%20portrait%20with%20clean%20background%2C%20modern%20professional%20appearance&width=200&height=200&seq=satyan-testimonial&orientation=squarish',
      quote: 'The unified platform approach has streamlined our entire business workflow. Highly recommended!'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our incredible success stories speak for themselves
          </h2>
          <button className="text-blue-600 hover:text-blue-700 font-semibold whitespace-nowrap cursor-pointer">
            Read customer journeys →
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.position}</p>
                  <p className="text-sm text-blue-600 font-medium">{testimonial.company}</p>
                </div>
              </div>

              {testimonial.stat ? (
                <div className="text-center">
                  <div className="text-4xl font-bold text-blue-600 mb-2">{testimonial.stat}</div>
                  <p className="text-gray-700">{testimonial.statDescription}</p>
                </div>
              ) : (
                <blockquote className="text-gray-700 italic">
                  "{testimonial.quote}"
                </blockquote>
              )}

              <div className="mt-6 flex justify-center">
                <button className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                  <i className="ri-play-fill text-white text-xl"></i>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
            Activate Free Trial
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
